import { combineReducers } from "redux";
import activeTab from "./activeTab";
import getBirthdayData from "./getBirthdayData";
import getBirthdaysInMonthData from "./getBirthdaysInMonth";
import selectedDate from "./selectedDate";

const birthdayReducer = combineReducers({
  getBirthdayData,
  activeTab,
  getBirthdaysInMonthData,
  selectedDate,
});

export default birthdayReducer;
